import type { IconSvgObject } from './types';

const WifiLowIcon: IconSvgObject = [
  ["path", { d: "M8.5 15.9293C9.43464 15.0132 10.6912 14.5 12 14.5C13.3088 14.5 14.5654 15.0132 15.5 15.9293M12.1256 19.2506H12.0006M12.2506 19.2506C12.2506 19.3887 12.1387 19.5006 12.0006 19.5006C11.8625 19.5006 11.7506 19.3887 11.7506 19.2506C11.7506 19.1126 11.8625 19.0006 12.0006 19.0006C12.1387 19.0006 12.2506 19.1126 12.2506 19.2506Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WifiLowIcon;
